
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import { shinjukuKaijinKaijinTopImage } from "@src/constants/images";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import ListBox from "@src/components/ListBox";
import GoogleMap from "@src/components/GoogleMap";
export const meta = {
  path: "/media/shinjuku/kaijin",
  title: "【鬼旨ラーメングランプリ出演】新宿魚介ラーメンの名店「麺屋 海神」の人気の秘密",
  description: "フジテレビ、鬼旨ラーメングランプリに出場！新宿から徒歩30秒という異例の近さに位置する魚介ラーメン店。それが、「麺屋 海神」。澄み切った黄金のスープ、独特の麺の製法など、店主のこだわりが詰まった逸品を求めて連日行列ができています。食べログも高評価をつけるお店の人気の秘密が何かを迫っていきたいと思います！",
  topImg: shinjukuKaijinKaijinTopImage,
  author: murakamiMasanori,
  tags: ["新宿", "ラーメン", "有名店", "駅近", "人気店", "お店の紹介", "1人メシ"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`ラーメンの名店が紹介される、フジテレビ「鬼旨ラーメングランプリ」にも出演。新宿から徒歩 30 秒という異例の近さに位置する魚介ラーメン店「麺屋 海神」。`}</p>
    <p>{`澄み切った黄金のスープはどのようにして作られているのか？独特の麺の製法は何か？`}<strong parentName="p"><em parentName="strong">{`食べたあとにおにぎりで雑炊！？`}</em></strong>{`など、「麺屋 海神」ならではの秘密があります！`}</p>
    <p>{`食べログも高評価をつけるお店の人気の秘密が何かを迫っていきたいと思います！`}</p>
    <h2>{`麺屋 海神とは？`}</h2>
    <p>{`新宿駅から徒歩 30 秒というとてつもない好立地にたたずむ。塩ラーメンの名店が「麺屋 海神」。
食べログの評価も`}<strong parentName="p">{`3.77`}</strong>{`(2020 年 5 月時点)という高評価で、新宿ラメーンの中で３本の指に入れるとされている超人気店。
数々の番組にも取り上げられている「麺屋 海神」ですが、その人気の秘密は何なのか？に迫っていきたいと思います。`}</p>
    <hr></hr>
    <h2>{`「麺屋 海神」こだわりのスープ`}</h2>
    <p>{`###「麺屋 海神」澄み渡る黄金の魚介スープ
麺屋海神のスープは底まで見渡せるくらい透き通ったスープになっています。
この写真を見ると、「麺屋 海神」のスープはまさに黄金に輝いていますよね。`}</p>
    <InstaImage postId="Bn-70YflMMp" mdxType="InstaImage" />
    <h4>{`日替わり５種の魚を仕入れあら炊き`}</h4>
    <p>{`このような形で壁にスープに使用している魚が張り出されています！
張り紙がおおきい...！`}</p>
    <InstaImage postId="B8Y0Uc4nEqq" mdxType="InstaImage" />
    <h3>{`魚の炊き方にも工夫が！？`}</h3>
    <p>{`毎日５種類の魚をあら炊きしているらしいのですが、その炊き方にもひと工夫があるそうです。
最初から魚を炊くのではなく、まずは魚を焼いて、その後にあら炊きをしているそう。
こうすることで、魚の旨味がギュッと凝縮され、魚の旨味が香るあっさりとした味わいになるそう！`}</p>
    <p>{`この一工夫が、「麺屋 海神」のあっさりとした風味のあるスープを作り出し、女性にも人気になっているのだと思います！`}</p>
    <hr></hr>
    <h2>{`「麺屋 海神」のコシのある特製麺`}</h2>
    <p>{`Bpvlit8gJ-P/
一見普通に見えるこの細麺にも、「麺屋 海神」の人気を作る秘密があります！
細麺なのにしっかりした歯ごたえを作っているのは、こんな作り方に秘密があるそうです！`}</p>
    <ListBox list={["２種類の小麦粉をブレンドして作る", "炭で浄化した特性の水で練った特注麺", "小麦粉のグルテンを結束させてコシを生むために、低温で熟成させてから使用"]} mdxType="ListBox" />
    <hr></hr>
    <h2>{`「麺屋 海神」の無料トッピング`}</h2>
    <p>{`塩の効いた出汁に合うトッピングが、白髪ねぎ、ショウガ、糸唐辛子、鶏つくねです。
とくにショウガの風味が、味を引き締めてくれるため、楽しめるようになっています！`}</p>
    <InstaImage postId="BHgh4o4j2N0" mdxType="InstaImage" />
    <hr></hr>
    <h2>{`「麺屋 海神」の２度楽しめる食べ方？`}</h2>
    <p>{`「麺屋 海神」では、`}<strong parentName="p">{`へしこ焼おにぎり付き`}</strong>{`のメニューがあります！
これが、そのメニューです。`}</p>
    <InstaImage postId="B9wgKnbJYiK" mdxType="InstaImage" />
    <p>{`麺を食べ終わったあとに、へしこ焼おにぎりをスープに入れて、`}<strong parentName="p">{`雑炊`}</strong>{`として食べるという食べ方になります！`}</p>
    <InstaImage postId="B549SJDBMsK" mdxType="InstaImage" />
    <p>{`このようにラーメンで和風の雑炊が楽しめるのは嬉しいですよね！`}</p>
    <hr></hr>
    <h2>{`「麺屋 海神」の追加トッピング`}</h2>
    <h3>{`水菜のトッピング`}</h3>
    <p>{`さっぱりとしたら味をさらに楽しみたい方は水菜をつけたラーメンを！`}</p>
    <InstaImage postId="B87gR00gmZL" mdxType="InstaImage" />
    <h3>{`パクチーのトッピング`}</h3>
    <p>{`アクセントを加えたいという方には、こちらのパクチーをつけたラーメンを！`}</p>
    <InstaImage postId="B98tcaDgAn-" mdxType="InstaImage" />
    <h3>{`トッピング全部のせ`}</h3>
    <p>{`ガッツリ食べたいという方にはこちらのトッピング全部のせラーメンを！`}</p>
    <InstaImage postId="B9MTsfLpVQO" mdxType="InstaImage" />
    <h2>{`アクセス`}</h2>
    <p>{`冒頭にお伝えしたように、「麺屋 海神」は新宿徒歩 30 秒と好立地にあるため、迷わずにいけると思います！
ただ、新宿は迷いやすいエリアなので、マップを載せておきます！`}</p>
    <GoogleMap lat={35.6961153} lng={139.6055104} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`フジテレビ、鬼旨ラーメングランプリにも紹介されるほどの新宿ラーメン人気店「麺屋 海神」の人気の秘密についてご紹介してきましたが、いかがでしたでしょうか！？
新宿からの好立地で、魚介のラーメンが食べられるからこそ、たくさんのお客さまが行列作っているのだと思います！
是非、新宿でラーメンを食べたい！魚介の名店でラーメンが食べたい！といった方はチャレンジしてみてください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;